// extracted by mini-css-extract-plugin
module.exports = {"defaultUnitValue":"8px","maxWidth":"1200px","container":"container-module--container--1Il0e"};